import { Route, Router } from "wouter";
import AdminApp from "./admin/AdminApp";
import "./App.css";
import UserApp from "./user/UserApp";
import { ConfigProvider } from "antd";
import { memo } from "react";

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "rgb(4, 116, 184)",
          borderRadius: 2,
          // colorBgContainer: "#f6ffed",
        },
      }}
    >
      <div className="App">
        <Router>
          <Route path="/admin" component={AdminApp} />
          <Route path="/admin/*" component={AdminApp} />
          <Route path="/" component={UserApp} />
        </Router>
      </div>
    </ConfigProvider>
  );
}

export default memo(App);
